/**
 * Customer-facing locale for Non-Solar Proposal V2 (GS-7418).
 *
 * Priority:
 *  1. `template_settings.language` when not `default`
 *  2. Project `language_override` / `language`
 *  3. Host app locale (react-admin)
 */
export const resolveProposalDisplayLocale = ({
  templateLanguage,
  projectLanguage,
  appLocale = 'en',
}: {
  templateLanguage?: string | null
  projectLanguage?: string | null
  appLocale?: string
}): string => {
  const template = (templateLanguage ?? '').trim()
  if (template && template !== 'default') {
    return template.replace('_', '-')
  }

  const project = (projectLanguage ?? '').trim()
  if (project) {
    return project.replace('_', '-')
  }

  const app = (appLocale ?? 'en').trim()
  return app ? app.replace('_', '-') : 'en'
}
